<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    少年宫站<br>
站点介绍<br>
少年宫站位于红荔路下。北侧是风景优美的莲花山公园，南临深圳中心书城，更有充满笑声、童趣的少年宫和时常传来动听旋律的音乐厅。西侧建有儿童医院，呵护小朋友们的健康成长。东南侧伫立着地铁大厦。少年宫连接三四号线，有两种不同的风格。三号线少年宫的装修为白色天花搭配蓝色瓷砖，非常简约，同时也充满了活力和朝气，小朋友们经常进进出出，很是欢乐。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:15	00:02	3号线	2分15-20秒	4分30秒<br>
双龙	06:28	23:11	3号线	2分15-20秒	4分30秒<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	00:02	3号线	3分15秒	5分钟<br>
双龙	06:29	23:11	3号线	3分15秒	5分钟<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:22	01:02	3号线	3分15秒	5分钟<br>
双龙	06:29	00:11	3号线	3分15秒	5分钟<br>
福田口岸	--	--	4号线	--	--<br>
牛湖	--	--	4号线	--	--<br><br>
<br>
站点出口信息<br><br>
E出入口:<br>
红荔路（南）、中心书城捐血站、深圳图书馆、益田路、鹏程三路、深圳市儿童医院、深圳音乐厅、深圳中心书城、江苏大厦<br><br>
F1出入口:<br>
红荔路（北）、莲花山公园<br><br>
F2出入口:<br>
红荔路（北）、关山月美术馆<br><br>
公交换乘信息<br><br>
E出入口:<br>
公交站名： 中心书城北<br>
10，41，215，M183，M105，莲花山公园巴士1F2出入口｜少年宫111，M262，M173，M391，M555<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sihaoxian",
          title: "4号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>